export var CardClickPopupType = /*#__PURE__*/ function(CardClickPopupType) {
    CardClickPopupType[CardClickPopupType["None"] = 0] = "None";
    CardClickPopupType[CardClickPopupType["NormalClick"] = 1] = "NormalClick";
    CardClickPopupType[CardClickPopupType["TradeWindow"] = 2] = "TradeWindow";
    CardClickPopupType[CardClickPopupType["InformationPopup"] = 3] = "InformationPopup";
    CardClickPopupType[CardClickPopupType["ConfirmationPopup"] = 4] = "ConfirmationPopup";
    return CardClickPopupType;
}({});
